export default __webpack_public_path__ + "static/media/address-pc.bebcaacd.jpg";